module.exports = __webpack_public_path__ + "static/media/hyphen-black.9ed66d5e.svg";